import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getProfileEditPasswordSuccess } from '@selectors/profile';
import { getMfaPostSuccess } from '@selectors/mfa';
import usePrevious from 'lib/src/hooks/usePrevious';

const useProfileSuccessModal = () => {
    const [showSuccessModal, setShowSuccessModal] = useState<'password' | 'mfa' | null>(null);

    const editPasswordSuccess = useSelector(getProfileEditPasswordSuccess);
    const prevEditPasswordSuccess = usePrevious(editPasswordSuccess);
    const mfaPostSuccess = useSelector(getMfaPostSuccess);
    const prevMfaPostSuccess = usePrevious(mfaPostSuccess);

    useEffect(() => {
        if (!prevEditPasswordSuccess && editPasswordSuccess) {
            setShowSuccessModal('password');
        } else if (!prevMfaPostSuccess && mfaPostSuccess) {
            setShowSuccessModal('mfa');
        }
    }, [prevEditPasswordSuccess, editPasswordSuccess, prevMfaPostSuccess, mfaPostSuccess]);

    return {
        showSuccessModal,
        setShowSuccessModal,
    };
};

export default useProfileSuccessModal;
